import { render } from "./QToggle.vue?vue&type=template&id=35769834&scoped=true"
import script from "./QToggle.vue?vue&type=script&lang=js"
export * from "./QToggle.vue?vue&type=script&lang=js"

import "./QToggle.vue?vue&type=style&index=0&id=35769834&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35769834"]])

export default __exports__